import { styled } from '@mui/material';

export const Container = styled('div')();

export const TextContainer = styled('span')({
  display: 'inline-block',
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: '1.75rem',
  fontWeight: 'bold',
});
